const { getContentPublishDate } = require('./getContentPublishDate');

const getContentModificationDate = content => {
  const modificationDate = content.dateOverride?.timestamp || content.changed;
  const publishDate = getContentPublishDate(content);
  // Ensure modification date is not lower than publish date.
  return publishDate > modificationDate ? publishDate : modificationDate;
};

module.exports = { getContentModificationDate };
